import { withCompController } from '@wix/editor-elements-integrations/src/thunderbolt';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  ILottieEmbedCompProps,
  ILottieEmbedMapperProps,
  ILottieEmbedStateRefValues,
} from '../LottieEmbed.types';

export default withCompController<
  ILottieEmbedMapperProps,
  ILottieEmbedCompProps,
  never,
  ILottieEmbedStateRefValues
>(({ stateValues, mapperProps }) => {
  const { reducedMotion, experiments = {} } = stateValues;
  const canvasRendererExperiment = isExperimentOpen(
    experiments,
    'specs.thunderbolt.LottieUseCanvasForIOSDevices',
  );
  return { ...mapperProps, reducedMotion, canvasRendererExperiment };
});
